import styled from 'styled-components'
import sizing from 'styles/sizing'
import spacing from 'styles/spacing'
import colors from 'utils/styling/colors'

export const Wrapper = styled.div`
  ${sizing}
  ${spacing}

  background-color: rgba(${colors('pinturaBackground')});

  .pintura-editor {
    --color-background: ${({ theme }) => theme.pinturaBackground};
    --color-foreground: ${({ theme }) => theme.pinturaForeground};
    --color-primary: ${colors('secondary')};
  }

  /* Keep the util rail clickable above the Remove Background overlay. */
  .PinturaRoot > .PinturaNavMain {
    z-index: 4;
  }

  /* While Remove Background is the active tool, drop the selected fill from
     Pintura's own tab so only one rail entry reads as selected. */
  .PinturaNavMain:has([data-bg-removal-tab][aria-selected='true'])
    li[aria-selected='true']:not([data-bg-removal-tab])
    button {
    background-color: transparent;
    backdrop-filter: none;
  }
`
